import React, { Component } from 'react';
import { DatePicker, Select, Input, Radio, AutoComplete, Cascader } from 'antd';
import moment from 'moment';

const { Option } = Select;
const { TextArea } = Input; 
const RadioGroup = Radio.Group;
const { MonthPicker } = DatePicker;

class ComList extends Component {
    getDom = (param) => {
        const { params } = this.props;
        const { name, key, require, colon = true, option, attr = {}, display } = param;
        const { type } = option || {};
        const { left = {}, right = {} } = attr;
        const asterisk = <span style={{ color: 'red' }}>*</span>;

        const result = [];
        result.push(
            <div key={`${name}-${key}`} className="item-left" style={{ width: '28%', ...left }}>
                {require && name && asterisk}{name || (<span>&nbsp;</span>)}{colon && ':'}
            </div>
        );
        // 显示隐藏控制
        if (display) {
            const { symbol, key, toName = false, value = null } = display;
            if (symbol === 'eq') {
                if (value === null) {
                    if (!params[key]) {
                        return;
                    }
                } else if (value) {
                    if (toName) {
                        const { list } = this.props;
                        const tar = list.find(i => i.key === key);
                        const arr = tar.option.list || [];
                        const o = arr.find(a => a.value == params[key]);
                        if (!params[key] || !o || o.name !== value) {
                            return;
                        }
                    } else if (!params[key] || params[key] !== value) {
                        return;
                    }
                }
            }
        }
        if (key) {
            if (type === 'autoComplete') {
                const { list, style = {}, placeholder = '请选择', allowClear = true } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <AutoComplete
                            style={style}
                            allowClear={allowClear}
                            placeholder={placeholder}
                            value={params[key] ? String(params[key]) : undefined}
                            onChange={value => this.props.onChange(value, key)}
                            onSearch={value => this.props.onSearch(value, key)}
                            optionLabelProp="value"
                        >
                            {list.map(i => <Option key={String(i.value)} value={String(i.name)}>{i.name}</Option>)}
                        </AutoComplete>
                    </div>
                );
            } else if (type === 'select') {
                const { list, style = {}, placeholder = '请选择', allowClear = true, onFocus, disabled = false, mode = '' } = option;
                let setting = {},
                    value = params[key] ? String(params[key]) : undefined;
                if (mode === 'search_multiple') {
                    setting.mode = 'multiple';
                    setting.labelInValue = true;
                    setting.onSearch = value => this.props.onSearch(value, key);
                    setting.onFocus = () => this.props.onSearch('', key);
                    setting.notFoundContent = '无匹配结果';
                    setting.defaultActiveFirstOption = false;
                    setting.filterOption = false;

                    value = params[key] || [];
                }
                if (mode === 'multiple') {
                    setting.mode = 'multiple';
                    setting.filterOption = false;

                    value = params[key] || [];
                }
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <Select
                            style={style}
                            disabled={disabled}
                            allowClear={allowClear}
                            placeholder={placeholder}
                            value={value}
                            onChange={value => this.props.onChange(value, key)}
                            onFocus={onFocus ? onFocus : () => null}
                            {...setting}
                        >
                            {list.map(i => <Option key={i.value} title={i.name} disabled={i.disabled}>{i.name}</Option>)}
                        </Select>
                    </div>
                );
            } else if (type === 'monthPicker') {
                const { format, style = {}, placeholder = '请选择', allowClear = true, disabled = false } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <MonthPicker
                            style={style}
                            format={format}
                            disabled={disabled}
                            allowClear={allowClear}
                            placeholder={placeholder}
                            value={params[key] ? moment(params[key]) : null}
                            onChange={(date, dateString) => this.props.onChange(dateString, key)}
                        />
                    </div>
                );
            } else if (type === 'textArea') {
                const { rows = 4, style = {}, limit, placeholder = '请填写' } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <TextArea
                            rows={rows}
                            style={style}
                            value={params[key]}
                            placeholder={placeholder}
                            onChange={e => this.props.onChange(e.target.value, key)}
                        />
                    </div>
                );
                if (limit) {
                    result.push(
                        <p style={{ ...style, float: 'right', textAlign:'right', color:'#ccc' }}>{(params[key] && params[key].length) || 0}/{limit}</p>
                    );
                }
            } else if (type === 'radio') {
                const { list } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <RadioGroup
                            options={list}
                            value={params[key] ? String(params[key]) : undefined}
                            onChange={e => this.props.onChange(e.target.value, key)}
                        />
                    </div>
                );
            } else if (type === 'input') {
                const { style = {}, disabled = false, placeholder = '请输入' } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <Input
                            style={style}
                            maxLength="200"
                            disabled={disabled}
                            value={params[key]}
                            placeholder={placeholder}
                            onChange={e => this.props.onChange(e.target.value, key)}
                        />
                    </div>
                );
            } else if (type === 'cascader') {
                const { style = {}, disabled = false, allowClear = true, placeholder = '请选择', list } = option;
                result.push(
                    <div key={key} className="item-right" style={{ width: '72%', ...right }}>
                        <Cascader
                            allowClear={allowClear}
                            style={style}
                            disabled={disabled}
                            placeholder={placeholder}
                            options={list}
                            value={params[key]}
                            onChange={value => this.props.onChange(value, key)}
                        />
                    </div>
                );
            }
        }
        return result;
    }

    render() {
        const { list } = this.props;
        const result = list.map((item, index) => {
            if (!Array.isArray(item)) {
                const res = this.getDom(item);
                if (res) {
                    return <li key={index} className="modal-item">{this.getDom(item)}</li>;
                } else {
                    return null;
                }
            } else {
                const [arr1, arr2] = item;
                return <li key={index} className="modal-item">{this.getDom(arr1)}{this.getDom(arr2)}</li>;
            }
        });
        return (
            <ul className="modal-list">
                {result}
            </ul>
        )
    }
}

export default ComList;


// WEBPACK FOOTER //
// ./src/components/common/ComList.js